export default "__VITE_ASSET__a8ceaa1a__"